/*
 * @FileName       : reports.actions.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action class for reports.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { action } from 'typesafe-actions';
import { UI } from '../constants/actions';
import { AppMenuState, InventoryFilterState } from '../models/common/ui';

export const setSelectedCustomer = (data: any) => action(UI.SET_CUSTOMER, data);
export const setSelectedDateRange = (data: any) => action(UI.SET_SELECTED_DATE_RANGE, data);
export const setSelectedExpiryDate = (data: any) => action(UI.SET_SELECTED_EXPIRY_DATE, data);
export const setSelectedHistoryDate = (data: any) => action(UI.SET_SELECTED_HISTORY_DATE, data);
export const setSelectedTransmittalDate = (data: any) => action(UI.SET_SELECTED_TRANSMITTAL_DATE, data);

export const setMoreFilterValue = (data: any) => action(UI.SET_MORE_FILTER_VALUE, data);
export const setSelectedCabinetType = (data: any) => action(UI.SET_SELECTED_CABINET_TYPE, data);

export const storeCustomer = (data: any) => action(UI.STORE_CUSTOMER, data);

export const setNavigationState = (data: AppMenuState) => action(UI.NAVIGATE, data);
export const navigationStateSuccess = (data: AppMenuState) => action(UI.NAVIGATE_RESPONSE, data);
export const setNavDrawer = (open: boolean) => action(UI.SET_NAV_DRAWER, open);

export const setNavState = (navState: any) => action(UI.SET_NAV_STATE, navState);

export const showLoader = (isLoading: boolean) => action(UI.SHOW_LOADER, isLoading);

export const cloudManagementLinkLoading = (payload: boolean) => action(UI.CLOUD_MGNT_LINK_LOADING, payload);

export const setUrlFilter = (queryString: string) => action(UI.SET_URL_FILTER, queryString);

export const setInventoryReportFilterState = (data: InventoryFilterState) => action(UI.SET_INVENTORY_STATE, data);
export const setInventoryReportFilterStateSuccess = (data: InventoryFilterState) =>
	action(UI.GET_INVENTORY_STATE, data);

export const setApiError = (payload: { errorMessage: string; severity: string; title: string } | null) =>
	action(UI.SET_API_ERROR, payload);

export const setAuthProcessing = (payload: boolean) => action(UI.AUTH_PROCESSING, payload);

export const resetAllFilters = () => action(UI.RESET_ALL_FILTERS);

export const setGlobalRowsPerPage = (data: any) => action(UI.SET_GLOBAL_ROWS_PER_PAGE, data);

export const disableSerialNumberFilter = (disabled: boolean) => action(UI.DISABLE_SERIAL_NUMBER_FILTER, disabled);
export const disableOwnershipFilter = (disabled: boolean) => action(UI.DISABLE_OWNERSHIP_FILTER, disabled);
